import * as React from "react";
import { ExternalLink } from "../../../../newcomponents/table/components/ExternalLink";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";

interface Props {}
export const CloudaccountCreateAzureConfigurationSubscriptionId: React.FC<Props> = () => {
  return (
    <>
      <ul className="pl-8">
        <li className="list-decimal mb-6 ml-4">
          Sign into the <ExternalLink url="https://portal.azure.com/" label="Azure Portal" disableCopy />
        </li>
        <li className="mb-6 list-decimal ml-4">
          Navigate to the <span className="font-semibold">Subscriptions</span> blade.
        </li>
        <li className="mb-2 list-decimal ml-4">
          Copy the <span className="font-semibold">Subscription ID</span> from the list.
        </li>
        <div
          className="flex items-center justify-center mb-6"
          style={{ width: 672, height: 108, border: "1px solid rgb(223, 223, 223)" }}
        >
          <img
            className="object-container"
            style={{ width: 672, height: 108 }}
            src={"/resources/howto/azure_subscriptionIdSteps.png"}
            alt={"how do I get my azure subscription id?"}
          />
        </div>
        <CpFormItem>
          <CpLabel name="azure.subscriptionId">Azure Subscription ID</CpLabel>
          <CpInput name="azure.subscriptionId" />
          <CpErrorWarning name="azure.subscriptionId" />
        </CpFormItem>
        <li className="list-decimal mt-6 mb-4 ml-4">You can close this wizard.</li>
      </ul>
    </>
  );
};
